export default "__VITE_ASSET__CN6u2cJG__"